import installSheetFactory, { IInstallSheet } from './models/installSheetModel';
import { IJobCost } from './models/jobCostModel';
import modelSetFactory from './modelSet';


export function getInstallSheets(target: IJobCost) {

	let installSheets = modelSetFactory<IInstallSheet>([], installSheetFactory)
	if (target && target.installSheets) {
		installSheets = target.installSheets;
		if (jobCostSchemaVersionCheck(target, 2)) {
			const currentChangeOrderKey = target.currentChangeOrder && target.currentChangeOrder.key;
			installSheets = installSheets.filter(item => item.changeOrderKey === currentChangeOrderKey)
		}
	}
	return installSheets
}

export function jobCostSchemaVersionCheck(item: IJobCost, schemaVersionTest: number) {
	const schemaVersion = item && item.schemaVersion || 0;
	const result = schemaVersion >= schemaVersionTest;
	return result;

}
